import { render } from 'react-dom';
import Root from './root';
import { APP_CONTAINER_ID } from './consts';
import './globalSearch-analytics';
// Debug mode in chrome for Preact

if (process.env.NODE_ENV === 'development') {
    import('preact/debug');
}

function initApp() {
    const appContainer = document.querySelector(`#${APP_CONTAINER_ID}`);
    appContainer.innerHTML = '';

    render(<Root />, appContainer);
}

if (document.readyState === 'loading') {
    // loading state, waiting for the event
    document.addEventListener('DOMContentLoaded', initApp);
} else {
    // DOM is ready!
    initApp();
}
